import { render, staticRenderFns } from "./PlayerAvatar.vue?vue&type=template&id=deb535b4&scoped=true&"
import script from "./PlayerAvatar.vue?vue&type=script&lang=js&"
export * from "./PlayerAvatar.vue?vue&type=script&lang=js&"
import style0 from "./PlayerAvatar.vue?vue&type=style&index=0&id=deb535b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb535b4",
  null
  
)

export default component.exports